import React, { useMemo } from "react";
import { ItemType, Selector, Space } from "@thenounproject/lingo-core";
import { Inspectable } from "@constants/Inspector";
import { DisplayProperties } from "@redux/actions/items/useBatchSaveItems";
import { getSharedAttribute } from "./utils";

type Props = {
  inspectables: Inspectable[];
  space: Space;
  onUpdateDisplayProps: (displayProperties: DisplayProperties, items?: Inspectable[]) => void;
};

const alignmentOptions = [
  { value: "leading", iconId: "content.image-left", tooltip: "Image Left" },
  { value: "top", iconId: "content.image-above", tooltip: "Image Above" },
  { value: "trailing", iconId: "content.image-right", tooltip: "Image Right" },
];

export const LayoutOptions: React.FC<Props> = ({ inspectables, onUpdateDisplayProps }) => {
  const canAdjustAlignment = inspectables.some(i => {
    const type = i.item?.type;
    return ![ItemType.note, ItemType.codeSnippet].includes(type!);
  });

  const imageAlignment = useMemo(() => {
    const getDisplayProperties = (i: Inspectable) => i.item?.displayProperties;
    return getSharedAttribute(inspectables, i => getDisplayProperties(i)?.imageAlignment) || null;
  }, [inspectables]);

  if (!canAdjustAlignment) return null;

  return (
    <Selector
      value={imageAlignment}
      options={alignmentOptions}
      onChange={val =>
        onUpdateDisplayProps(
          { image_alignment: val as "leading" | "top" | "trailing" },
          inspectables
        )
      }
    />
  );
};
